import React from 'react';
import { useDispatch } from 'react-redux';
import numeral from 'numeral';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

import { cleanUpBomData } from 'shared/product_tabs/tab_parts/bomSlice';

const Parts = (props) => {
  const { subTotal, selected } = props;
  const dispatch = useDispatch();

  if (!selected) return null;

  const onDelete = () => {
    dispatch(cleanUpBomData(true));
  };

  return (
    <div className="cart-section stencils">
      <div className="title">
        Electronic Components
        <button type="button" onClick={onDelete} className="btn btn-link float-right btn-delete">
          <FontAwesomeIcon icon={faTrashCan} />
        </button>
      </div>
      <div className="price">
        {subTotal === undefined ? null : `$${numeral(subTotal).format('0,0.00')}`}
      </div>
      <div className="toggle-details" />
    </div>
  );
};

export default Parts;
